import { createContext, useState, useMemo } from 'react';
import Api from './api';
import { parsePermissionString } from '../../../../src/lib/simpleACL/parsePermissionString';
import { checkAccess } from '../../../../src/lib/simpleACL/checkAccess';

const Context = createContext();
function UserHOC ({ children }) {
	const [user, setUser] = useState(() => window.INITIAL_DATA.user);
	const parsedPermissions = useMemo(() => user && parsePermissionString(user.acl.rules), [user?.acl.rules]);

	async function logIn ({ username, password, token }) {
		const result = await Api.login({
			username, password, token
		});
		if (result.status) {
			setUser(result.user);
			return result;
		}
		if (result.requiredTotp) {
			return {
				user: result.user,
				status: false,
				requiredTotp: true
			};
		}
		const err = new Error(result.message);
		err.body = result;
		throw err;
	}

	async function logOut () {
		await Api.logOut();
		setUser(null);
	}

	return (
		<Context.Provider value={{
			user,
			logIn,
			logOut,
			setUser,
			checkAccess: (rule) => checkAccess(parsedPermissions, rule),
			beginSSO: () => Api.beginSSO()
		}}
		>
			{children}
		</Context.Provider>
	);
}

export default Context;
export {
	Context as UserContext,
	UserHOC
};
